<template>
  <div v-if="show" class="app-topbar">
    <button class="app-topbar__close" @click.prevent="() => $emit('onClose')">
      &times;
    </button>
    <div class="app-topbar__container text-center">
      Your app has been updated. Click
      <a href="javascript:;" onclick="location.reload()">refresh</a>
      to view updates.
    </div>
  </div>
</template>

<script>
export default {
  name: "AppTopbar",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.app-topbar {
  background-color: $gray-250;
  color: $gray-700;
  font-size: 0.875rem;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10001;

  &__container {
    padding: 0.9375rem;
  }

  a {
    color: currentColor;
    text-decoration: underline;
  }

  &__close {
    background-color: transparent;
    border-color: transparent;
    bottom: 0;
    color: currentColor;
    font-size: 1.5rem;
    height: 2rem;
    line-height: 2rem;
    margin: 0;
    opacity: 0.7;
    padding: 0;
    position: absolute;
    right: calc(0.9375rem / 2);
    top: calc(0.9375rem / 2);
    width: 2rem;

    &:hover {
      cursor: pointer;
      opacity: 1;
    }
  }
}
</style>
